import { findPendingBrDuplicatesByRegistrationNo } from '../utils/brConfirmSubmit';

/**
 * 同号待审二次确认（新执照提交 / 更名申请共用）。
 * 宿主覆盖：isDuplicatePendingBusy、executeDuplicatePendingSubmit。
 */
export default {
  data() {
    return {
      showDuplicatePendingConfirm: false,
      pendingDuplicateSubmitPayload: null,
    };
  },
  methods: {
    isDuplicatePendingBusy() {
      return false;
    },
    hasPendingBrDuplicates(list, registrationNo, nameChanges) {
      return findPendingBrDuplicatesByRegistrationNo(
        list,
        registrationNo,
        nameChanges,
      ).length > 0;
    },
    openDuplicatePendingConfirm(payload) {
      this.pendingDuplicateSubmitPayload = payload;
      this.showDuplicatePendingConfirm = true;
    },
    closeDuplicatePendingConfirm() {
      if (this.isDuplicatePendingBusy()) {
        return;
      }
      this.showDuplicatePendingConfirm = false;
      this.pendingDuplicateSubmitPayload = null;
    },
    async confirmDuplicatePendingSubmit() {
      const payload = this.pendingDuplicateSubmitPayload;
      if (!payload || this.isDuplicatePendingBusy()) {
        return;
      }
      this.showDuplicatePendingConfirm = false;
      this.pendingDuplicateSubmitPayload = null;
      await this.executeDuplicatePendingSubmit(payload);
    },
    async executeDuplicatePendingSubmit() {
      // 由宿主实现实际提交
    },
  },
};
